import React from 'react';
import SignInCard from '../containers/SignInCard';
import HomeLayout from '../containers/menu/HomeLayout';

const LoginPage = () => {

  return (
    <div>
      <HomeLayout>
        <SignInCard />
      </HomeLayout>
    </div>
  )
};

export default LoginPage;
